import React from 'react';
import Tooltip from '@mui/material/Tooltip';

import { IconButton, Typography, InfoIcon } from '@occc/ui-design-system';

export const CustomTooltip: React.FC<any> = ({ title, description }) => {
  return (
    <Tooltip
      title={
        <>
          <Typography gutterBottom color='inherit' display='flex' alignItems='center'>
            <InfoIcon fontSize='small' sx={{ mr: 0.5 }} />
            {title}
          </Typography>
          <Typography variant='body2' color='inherit'>
            {description}
          </Typography>
        </>
      }
      placement='top'
      sx={{ p: 2 }}
    >
      <IconButton size='small' sx={{ ml: 1, p: 0 }}>
        <InfoIcon fontSize='inherit' />
      </IconButton>
    </Tooltip>
  );
};
